<section class="chapters" aria-label="Capítulos">
  <h3 class="chapters__title">Capítulos</h3>
  @if (itens().length) {
    <ol class="chapters__list">
      @for (capitulo of itens(); track capitulo.startSeconds) {
        <li>
          <button
            type="button"
            class="chapters__chip"
            [disabled]="!temVideo()"
            [title]="capitulo.dica"
            (click)="irPara.emit(capitulo.startSeconds)">
            <span class="chapters__time">{{ capitulo.tempo }}</span>
            {{ capitulo.title }}
          </button>
        </li>
      }
    </ol>
  } @else if (processando()) {
    <p class="chapters__soon">
      <i class="pi pi-sparkles" aria-hidden="true"></i>
      O Cog está dividindo a reunião em capítulos.
    </p>
  } @else if (semCapitulos()) {
    <p class="chapters__soon">
      <i class="pi pi-info-circle" aria-hidden="true"></i>
      O Cog não dividiu esta reunião em capítulos.
    </p>
  } @else {
    <p class="chapters__soon">
      <i class="pi pi-sparkles" aria-hidden="true"></i>
      Depois da transcrição, o Cog divide a reunião em capítulos para você pular direto para cada
      assunto.
    </p>
  }
</section>
